// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"829da38a","732":"257d3181"}[chunkId] + ".chunk.js";
};